const TerminationActionTypes = {
  GET_TERM_DATA_START: 'GET_TERM_DATA_START',
  GET_TERM_DATA_SUCCESS: 'GET_TERM_DATA_SUCCESS',
  GET_TERM_DATA_FAILURE: 'GET_TERM_DATA_FAILURE',

  SET_FORWARDING_EMAIL: 'SET_FORWARDING_EMAIL',
  SET_TERM_DEPARTMENT: 'SET_TERM_DEPARTMENT',
  SET_TERM_POSITION: 'SET_TERM_POSITION',
  SET_TERM_EMAIL: 'SET_TERM_EMAIL',
  SET_TERM_NOC: 'SET_TERM_NOC',
  SET_TERM_NAVITAIRE: 'SET_TERM_NAVITAIRE',
  SET_TERM_LOCATION: 'SET_TERM_LOCATION',
  SET_TERM_UBER: 'SET_TERM_UBER',
  SET_TERM_LYFT: 'SET_TERM_LYFT',
  SET_SUSPEND_AZURE: 'SET_SUSPEND_AZURE',
};

export default TerminationActionTypes;
